module.exports = __webpack_public_path__ + "c9ab436e824d579f430b97d06a6fcbd4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/LiberationMono-Regular-webfont.woff
// module id = 236
// module chunks = 0